module.exports = __webpack_public_path__ + "3e30f2d58729cd83346201b7d1cc944b.svg";